require('./genderAndBirthController.js')
require('./modalBadgeController.js')
require('./modalBadgeReceivedController.js')
require('./modalCommunityStreamController.js')
require('./modalController.js')
require('./modalNotificationsController.js')
require('./redeemCouponFlowController.js')
require('./redeemCouponFlowOrangeController.js')
require('./voucherFormController.js')
